import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import "react-vertical-timeline-component/style.min.css";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Provider } from 'react-redux';
import Store from 'VENDOR/Store/Store';

library.add(fab, far, fas);

ReactDOM.render(
  <React.StrictMode>
   <Provider store={Store}>
			<App />
		</Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
